export const TABLE_DATE_FORMAT = 'ddd. D MMM. YY';
